<template>
  <div class="w-full">
    <el-select
      v-model="city"
      id="selectCity"
      ref="selectCity"
      class="select-city-component"
      filterable
      remote
      value-key="placeId"
      :autocomplete="'__always'"
      :remote-method="debouncedSearch"
      :loading="isSearchingPlaces"
      :popper-class="'select-city-component-popper'"
      @change="handleSelectChange($event)"
      @input="handleSelectTyping">

      <el-option v-for="city in cityOptions"
        :key="city.placeId"
        :label="city.description"
        :value="city">
      </el-option>
    </el-select>

    <!-- Show loader if searching place details -->
    <div v-show="isFetchingPlaceDetails" class="fetching-place-details
      absolute bg-white
      text-slate-400
      text-xs text-center
      flex justify-center items-center
      inset-0 whitespace-nowrap overflow-hidden
      text-ellipsis
      border border-solid border-[#ccccccc]">{{$t('label.loading')}}</div>
  </div>
</template>

<script src="./select-city.js"></script>
<style lang="scss" src="./select-city.scss"></style>
